import { ScrollTrigger } from "gsap/ScrollTrigger";

import { clamp, wavePath } from "./math";

const W = 1440;
const H = 160;
const NS = "http://www.w3.org/2000/svg";

const LAYERS = [
  { crests: 5, lead: 0.22, opacity: 0.28, speed: 0.8, shift: 1.9 },
  { crests: 5.5, lead: 0.11, opacity: 0.55, speed: 1.1, shift: 0.9 },
  { crests: 6, lead: 0, opacity: 1, speed: 1.4, shift: 0 },
] as const;

export function initWaveBands(reduced: boolean): void {
  document.querySelectorAll<HTMLElement>("[data-waves]").forEach((band) => {
    const trigger = document.getElementById(band.dataset.trigger ?? "");
    const target = band.parentElement;
    if (!trigger || !target) return;
    const to = band.dataset.to ?? "#FFFFFF";

    const svg = document.createElementNS(NS, "svg");
    svg.setAttribute("viewBox", `0 0 ${W} ${H}`);
    svg.setAttribute("preserveAspectRatio", "none");
    const paths = LAYERS.map((layer) => {
      const p = document.createElementNS(NS, "path");
      p.setAttribute("fill", to);
      p.setAttribute("opacity", String(layer.opacity));
      svg.appendChild(p);
      return p;
    });
    band.replaceChildren(svg);

    let progress = 0;
    let time = 0;
    const draw = () => {
      LAYERS.forEach((layer, i) => {
        const level = clamp(0.06 + progress * 0.62 + layer.lead * Math.min(1, progress * 3));
        const amplitude = H * 0.11 * Math.min(1, level * 3);
        const phase = progress * Math.PI * 2 * 1.2 * layer.speed + time * layer.speed + layer.shift;
        paths[i]?.setAttribute("d", wavePath(W, H, level, amplitude, layer.crests, phase));
      });
    };

    ScrollTrigger.create({
      trigger,
      endTrigger: target,
      start: "bottom bottom",
      end: "top top",
      onUpdate: (self) => {
        progress = self.progress;
        draw();
      },
      onRefresh: (self) => {
        progress = self.progress;
        draw();
      },
    });
    draw();
    if (reduced) return;

    let visible = false;
    let last = 0;
    const tick = (now: number) => {
      if (!visible) return;
      time += Math.min(0.05, (now - last) / 1000) * 0.9;
      last = now;
      draw();
      requestAnimationFrame(tick);
    };
    new IntersectionObserver(([entry]) => {
      const was = visible;
      visible = Boolean(entry?.isIntersecting);
      if (visible && !was) {
        last = performance.now();
        requestAnimationFrame(tick);
      }
    }).observe(band);
  });
}
